import '../Styles.css';
import { jwtDecode } from "jwt-decode";
import axios from 'axios';
import React from 'react';
import { Middleware, MiddlewareAdmin, MiddlewareSuperUser } from './Middleware';
import { TokenValidateExpiration } from './Token';
import { useParams } from 'react-router-dom';

const token = localStorage.getItem("token");

function SuperUserProviderChangeStatus(rfc) {
    var changeStatus = document.getElementById("changeStatus").value;

    axios.post(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/super-user/provider/change/status/'+token, {
        RFC: rfc,
        Estatus: changeStatus,
        }, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    ).then(response => {
        window.location.href = '/super-usuario';
    })
    .catch(error => {
        window.scrollTo(0, 0);
        console.log(error);
    });
}

function AdminProviderBankAccountCertPetition(id, provider, rfc) {
    window.scrollTo(0, 0);
    document.getElementById("messageError").style.display = "none";
    document.getElementById("messageError").innerHTML = "";
    document.getElementById("ChgB").style.display = "block";

    const token = localStorage.getItem("token");
    axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/provider/bank-accounts/certificate/init/' + id+'/'+token, {}, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        window.scrollTo(0, 0);
        document.getElementById("ChgB").style.display = "none";
        document.getElementById("messageSuccess").style.display = "block";
        document.getElementById("messageSuccess").innerHTML = "La cuenta bancaria ha iniciado su proceso de certificación, recargando la pagina, por favor espere...";
        setTimeout(() => {
            window.location.href = '/administrador-proveedor-revision/'+provider+'/'+rfc;
        }, 3000);
    });
}

function SuperUserProviderRevise() {
    Middleware();
    MiddlewareSuperUser();

    const token = localStorage.getItem("token");
    TokenValidateExpiration(token);

    var decode = "";

    decode = jwtDecode(token);

    var { provider } = useParams();

    var { rfc } = useParams();

    var { estatus } = useParams();

    //Get provider general data
    const [data, setData] = React.useState([]);
    const [regimenCapital, setRegimenCapital] = React.useState([]);
    const [contribuyente, setContribuyente] = React.useState([]);
    const [regimenFiscal, setRegimenFiscal] = React.useState([]);
    const [actividadEconomica, setActividadEconomica] = React.useState([]);
    const [proveedor, setProveedor] = React.useState([]);
    const [tipoProveedor, setTipoProveedor] = React.useState([]);
    const [categoriaAbastoSuministro, setCategoriaAbastoSuministro] = React.useState([]);
    const [subcategoriaAbastoSuministro, setSubcategoriaAbastoSuministro] = React.useState([]);

    React.useEffect(() => {
        axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/admin/provider/general-data/' + provider +'/'+token, {}, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        setData(response.data.GeneralData[0]);
        setRegimenCapital(response.data.RegimenCapital);
        setContribuyente(response.data.Contribuyente);
        setRegimenFiscal(response.data.RegimenFiscal);
        setActividadEconomica(response.data.ActividadEconomica);
        setProveedor(response.data.Proveedor);
        setTipoProveedor(response.data.GeneralData[0].TipoProveedor);
        setCategoriaAbastoSuministro(response.data.CategoriaAbastoSuministro);
        setSubcategoriaAbastoSuministro(response.data.SubcategoriaAbastoSuministro);
    });
    }, []);

    const [bankAccounts, setbankAccounts] = React.useState([]);

    React.useEffect(() => {
        axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/admin/provider/bank-accounts/' + provider+'/'+token, {}, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        setbankAccounts(response.data);
    });
    }, []);

    return (
        <div className='Container'>
            <div className='Navbar'>
                <div>
                    <h5 className='text-white'>Portal de proveedores</h5>
                </div>
            </div>
            <div className='Section'>
                <div className='Header'>
                    <div className="text-center">
                        <div className='row'>
                            <div className='col-md-6 Text-left'>
                                <label className='mt-1 Text-Gray'><b>Usuario: </b>
                                    {  
                                        decode.email
                                    }
                                </label>
                            </div>
                            <div className='col-md-6 Text-right'>
                                <a href='/logout'>
                                    <label>
                                        Cerrar sesión
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fillRule="currentColor" className="bi bi-box-arrow-right m-1" viewBox="0 0 16 16">
                                            <path fillRule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z" />
                                            <path fillRule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z" />
                                        </svg>
                                    </label>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='Article'>
                    <div className="text-center">
                        <h1 className='Text-Red'>Proveedor {rfc}</h1>
                        <br></br>
                        <div>
                            <p><i id="ChgB" className="fa fa-spinner fa-spin Chg"></i></p>
                        </div>
                        <div className='d-flex justify-content-center'>
                            <label id='messageError' className='Error-Notification'></label>
                        </div>
                        <div className='d-flex justify-content-center'>
                            <label id='messageSuccess' className='Success-Notification'></label>
                        </div>
                        <br></br>
                        <h3 className='Text-Red Text-left'>Estatus</h3>
                        <div className="d-flex justify-content-center">
                            <form action={SuperUserProviderChangeStatus}>
                                <select className='Input-Style' id='changeStatus'>
                                    <option value={estatus}>
                                        {
                                            estatus == 0
                                            &&
                                            "Nuevo"
                                        }
                                        {
                                            estatus == 1
                                            &&
                                            "Registrado"
                                        }
                                        {
                                            estatus == 2
                                            &&
                                            "Pendiente modificar"
                                        }
                                        {
                                        estatus == 3
                                            &&
                                            "En progreso de modificar"
                                        }
                                        {
                                            estatus == 4
                                            &&
                                            "En revisión"
                                        }
                                        {
                                            estatus == 5
                                            &&
                                            "Registrado TIBCO"
                                        }
                                        {
                                            estatus == 6
                                            &&
                                            "Error"
                                        }
                                        {
                                            estatus == 10
                                            &&
                                            "En progreso registro"
                                        }
                                        {
                                            estatus == 100
                                            &&
                                            "Inhabilitado"
                                        }
                                    </option>
                                    <option value={0}>Nuevo</option>
                                    <option value={1}>Registrado</option>
                                    <option value={2}>Pendiente modificar</option>
                                    <option value={3}>En progreso de modificar</option>
                                    <option value={4}>En revisión</option>
                                    <option value={5}>Registrado TIBCO</option>
                                    <option value={6}>Error</option>
                                    <option value={10}>En progreso registro</option>
                                    <option value={100}>Inhabilitado</option>
                                </select>
                                <br></br>
                                <input type='button' className='Button-Style' value={"Enviar"} onClick={() => SuperUserProviderChangeStatus(rfc)}></input>
                            </form>
                        </div>
                        <h3 className='Text-Red Text-left'>Documentos</h3>
                        <br></br>
                        <br></br>
                        <h3 className='Text-Red Text-left'>Datos generales</h3>
                        <br></br>
                        <br></br>
                        <div className="container-fluid">
                                <div className="row">
                                    <div className="col-lg-4 col-md-6">
                                        <div>
                                            <label>Registro Federal de Contribuyentes</label>
                                            <br></br>
                                            <input type="input" name="rfc" id="rfc" className="form-control Input-Style" value={rfc} disabled></input>
                                        </div>
                                    </div>
                                    <div className="col-lg-8 col-md-6">
                                        <div>
                                            <label>Denominación/Razón Social</label>
                                            <br></br>
                                            <input type="input" name="RazonSocial" id="RazonSocial" className="form-control Input-Style" value={data.RazonSocial} disabled></input>
                                        </div>
                                    </div>
                                </div>
                                <br></br>
                                <br></br>
                                <div className="row">
                                    <div className="col-lg-4 col-md-6">
                                        <div>
                                            <label>Régimen Capital</label>
                                            <select name="RegimenCapital" id="RegimenCapital" aria-label="Default select example" className="form-select Input-Style" value={data.RegimenCapital} disabled>
                                                {
                                                    regimenCapital.map(item => (
                                                        <option value={item.Codigo} key={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                            <br></br>
                                            
                                        </div>
                                    </div>
                                    <div className="col-lg-8 col-md-6">
                                        <div>
                                            <label>Nombre Comercial</label>
                                            <br></br>
                                            <input type="input" name="NombreComercial" id="NombreComercial" className="form-control Input-Style" value={data.NombreComercial} disabled></input>
                                        </div>
                                    </div>
                                </div>
                                <br></br>
                                <br></br>
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div>
                                            <label>Tipo de Contribuyente</label>
                                            <br></br>
                                            <select name="TipoContribuyente" id="TipoContribuyente" aria-label="Default select example" className="form-select Input-Style" value={data.TipoContribuyente} disabled>
                                                {
                                                    contribuyente.map(item => (
                                                        <option value={item.Codigo} key={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div>
                                            <label>Régimen Fiscal</label>
                                            <br></br>
                                            <select name="RegimenFiscal" id="RegimenFiscal" aria-label="Default select example" className="form-select Input-Style" value={data.RegimenFiscal} disabled>
                                                {
                                                    regimenFiscal.map(item => (
                                                        <option value={item.Codigo} key={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div>
                                            <label>Actividad Económica</label>
                                            <br></br>
                                            <select name="ActividadEconomica" id="ActividadEconomica" aria-label="Default select example" className="form-select Input-Style" value={data.ActividadEconomica} disabled>
                                                {
                                                    actividadEconomica.map(item => (
                                                        <option value={item.Codigo} key={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <br></br>
                                <br></br>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div>
                                            <label>Régimen</label>
                                            <br></br>
                                            <input type="input" name="Regimen" id="Regimen" className="form-control Input-Style" value={data.Regimen} disabled></input>
                                        </div>
                                    </div>
                                </div>
                                <br></br>
                                <br></br>
                                <div className="row">
                                    <div className="col">
                                        <div>
                                            <label>Dirección Constancia Situación Fiscal</label>
                                            <br></br>
                                            <input type="input" name="DireccionFiscal" id="DireccionFiscal" className="form-control Input-Style" value={data.DireccionFiscal} disabled></input>
                                            <label></label>
                                        </div>
                                    </div>
                                </div>
                                <br></br>
                                <br></br>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div>
                                            <label>Tipo Proveedor</label>
                                            <br></br>
                                            <select name="TipoProveedor" id="TipoProveedor" aria-label="Default select example" className="form-select Select-Style" disabled required>
                                                {
                                                    data.TipoProveedor == ""
                                                    ?
                                                    <option value="">Selecciona...</option>
                                                    :
                                                    proveedor.map(item => (
                                                        item.Codigo == data.TipoProveedor
                                                        &&
                                                        <option value={item.Codigo} key={item.Codigo}>{item.Nombre}</option>       
                                                    ))
                                                }
                                                {
                                                    proveedor.map(item => (
                                                        <option value={item.Codigo} key={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div>
                                            <label className='Text-Red'></label><label>Registro REPSE</label>
                                            <br></br>
                                            <input type="input" name="RegistroREPSE" id="RegistroREPSE" className="form-control Input-Style" value={data.RegistroREPSE} disabled></input>
                                            <label></label>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div>
                                            <label>Categoria de Abasto y Suministro</label>
                                            <br></br>
                                            <select name="CategoriaAbastoSuministro" id="CategoriaAbastoSuministro" aria-label="Default select example" className="form-select Select-Style" value={data.CategoriaAbastoSuministro} disabled required>
                                                {
                                                    data.CategoriaAbastoSuministro == ""
                                                    ?
                                                    <option value="">Selecciona...</option>
                                                    :
                                                    categoriaAbastoSuministro.map(item => (
                                                        item.Codigo == data.CategoriaAbastoSuministro
                                                        &&
                                                        <option value={item.Codigo} key={item.Codigo}>{item.Nombre}</option>       
                                                    ))
                                                }
                                                {
                                                    categoriaAbastoSuministro.map(item => (
                                                        <option value={item.Codigo} key={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div>
                                            <label>Sub Categoría de Abasto y Suministro</label>
                                            <br></br>
                                            <select name="SubcategoriaAbastoSuministro" id="SubcategoriaAbastoSuministro" aria-label="Default select example" className="form-select Select-Style" value={data.SubcategoriaAbastoSuministro} disabled required>
                                                <option value="">Selecciona...</option>
                                                {
                                                    data.SubcategoriaAbastoSuministro == ""
                                                    ?
                                                    <option value="">Selecciona...</option>
                                                    :
                                                    subcategoriaAbastoSuministro.map(item => (
                                                        item.Codigo == data.SubcategoriaAbastoSuministro
                                                        &&
                                                        <option value={item.Codigo}>{item.Nombre}</option>       
                                                    ))
                                                }
                                                {
                                                    subcategoriaAbastoSuministro.map(item => (
                                                        <option value={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                        </div>
                                    </div>
                                    <br></br>
                                    <br></br>
                                </div>
                                <br></br>
                                <br></br>
                            </div>
                        <br></br>
                        <br></br>
                        <h3 className='Text-Red Text-left'>Cuestionario</h3>
                        <br></br>
                        <br></br>
                        <h3 className='Text-Red Text-left'>Contactos</h3>
                        <br></br>
                        <br></br>
                        <h3 className='Text-Red Text-left'>Cuentas bancarias</h3>
                        <br></br>
                        <br></br>
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th scope="col">Cuenta bancaria</th>
                                    <th scope="col">Clabe</th>
                                    <th scope='col'>Referencia 1</th>
                                    <th scope='col'>Referencia 2</th>
                                    <th scope="col">Beneficiario</th>
                                    <th scope="col">Estatus</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    bankAccounts 
                                    &&
                                    bankAccounts.map(item => (
                                        <tr id={"bankAccount"+item.id} key={"bankAccount"+item.id} value={"bankAccount"+item.id}>
                                            <td>
                                                {item.bankAccount}
                                            </td>
                                            <td>
                                                {item.Clabe}
                                            </td>
                                            <td>
                                                {item.Reference1}
                                            </td>
                                            <td>{item.Reference2}</td>
                                            <td>{item.Beneficiary}</td>
                                            <td>
                                                <input type='hidden' id="ccb" value={item.ccb}></input>
                                                {
                                                    item.ccb == 0
                                                    ?
                                                    <label>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-hourglass-split m-2" viewBox="0 0 16 16">
                                                            <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z"/>
                                                        </svg>
                                                        En proceso de certificación {item.ccb}
                                                    </label>
                                                    :
                                                    item.ccb == 1
                                                    ?
                                                    <label onClick={() => AdminProviderBankAccountCertPetition(item.id, provider, rfc)}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-patch-exclamation-fill m-2" viewBox="0 0 16 16">
                                                            <path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>
                                                        </svg>
                                                        Iniciar certificación
                                                    </label>
                                                    :
                                                    item.ccb == 2
                                                    ?
                                                    <label>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-hourglass-split m-2" viewBox="0 0 16 16">
                                                            <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z"/>
                                                        </svg>
                                                        En proceso de certificación {item.ccb}
                                                    </label>
                                                    :
                                                    item.ccb == 3
                                                    ?
                                                    <label>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-hourglass-split m-2" viewBox="0 0 16 16">
                                                            <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z"/>
                                                        </svg>
                                                        En proceso de certificación {item.ccb}
                                                    </label>
                                                    :
                                                    item.ccb == 4
                                                    ?
                                                    <label>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-hourglass-split m-2" viewBox="0 0 16 16">
                                                            <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z"/>
                                                        </svg>
                                                        En proceso de certificación {item.ccb}
                                                    </label>
                                                    :
                                                    item.ccb == 5
                                                    ?
                                                    <label>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-award-fill m-2" viewBox="0 0 16 16">
                                                            <path d="m8 0 1.669.864 1.858.282.842 1.68 1.337 1.32L13.4 6l.306 1.854-1.337 1.32-.842 1.68-1.858.282L8 12l-1.669-.864-1.858-.282-.842-1.68-1.337-1.32L2.6 6l-.306-1.854 1.337-1.32.842-1.68L6.331.864z"/>
                                                            <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1z"/>
                                                        </svg>
                                                        Cuenta certificada
                                                    </label>
                                                    :
                                                    item.ccb == 6
                                                    &&
                                                    <label>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16">
                                                            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>
                                                        </svg>
                                                        Cuenta no certificada {item.ccb}
                                                    </label> 
                                                }
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                        <br></br>
                        <br></br>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SuperUserProviderRevise;